import { Tipo_loteo } from './../../../models/tipo_loteo.model';
import { Component } from "@angular/core";
import { FormGroup, FormControl, Validators } from '@angular/forms';


@Component({
    selector: "page-tipo_loteo",
    templateUrl: "./tipo_loteo.component.html"
    
})


export class Tipo_loteoComponent {
    public rows = [];
    public actualRow;
    public tipo_loteo: Tipo_loteo;
    public form;
    
    constructor(){
        this.form = new FormGroup({
            loteo1: new FormControl('', Validators.required),
            loteo2:new FormControl('', Validators.required),
            loteo3:new FormControl('', Validators.required),
            
        })
        if(!JSON.parse(localStorage.getItem("tipo_loteo"))){
            localStorage.setItem("tipo_loteo", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("tipo_loteo"));
            this.form.controls['loteo1'].setValue(this.rows[0]?this.rows[0].loteo:'NO')
            this.form.controls['loteo2'].setValue(this.rows[0]?this.rows[0].loteo_construccion:'NO')
            this.form.controls['loteo3'].setValue(this.rows[0]?this.rows[0].loteo_dfl2:'NO')
        }
        this.tipo_loteo= {loteo:'',loteo_construccion:'',loteo_dfl2:''}
    }

    add_tipo_loteo(){
        localStorage.setItem("tipo_loteo",JSON.stringify([]));
        this.actualRow = localStorage.getItem("tipo_loteo");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            'loteo': this.form.value.loteo1, 
            'loteo_construccion': this.form.value.loteo2,
            'loteo_dfl2': this.form.value.loteo3,
        })
        localStorage.setItem("tipo_loteo", JSON.stringify(this.rows));
        console.log(JSON.parse(localStorage.getItem("tipo_loteo")));
    }
  
    delete_tipo_loteo(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("tipo_loteo", JSON.stringify(this.rows));
            }
        }
    }   
}